export enum ClaimMethodEnum {
  APIDX         = '00000165-1000-0000-0000-000000000001',
  ADAForm       = '00000165-1000-0000-0000-000000000002',

}
